module.exports = __webpack_public_path__ + "static/media/vector-4963.551cb654.svg";